import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=01a295d1"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=ts"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports